import { get } from 'lodash';
import { BLUE, RED } from '../../../../../utils/colors';

export const createBipickingTabs = (primaryOrder, secondaryOrder) => {
    return [
        {
            key: 'primary',
            icon: 'bipicking-a',
            color: BLUE,
            orderData: primaryOrder,
            relatedOrderId: get(secondaryOrder, 'id')
        },
        {
            key: 'secondary',
            icon: 'bipicking-b',
            color: RED,
            orderData: secondaryOrder,
            relatedOrderId: get(primaryOrder, 'id')
        }
    ];
};